<template>
  <Labelled
    :label="label"
    :error="error"
    :help-text="helpText"
    :help-text-html="helpTextHtml"
    :required="required"
  >
    <div
      :class="[
        'UIElement',
        $style.ImageInput,
        error && $style.ImageInput__hasError
      ]"
    >
      <div
        :class="[
          $style.ImageInput_control
        ]"
      >
        <ButtonGroup segmented>
          <Button type="primary" ref="input" @click="chooseImage">{{$t('Choose Image')}}</Button>
          <Button :disabled="!required || !value" @click="removeImage">{{$t('Remove')}}</Button>
        </ButtonGroup>
        <img v-if="value" :src="value" :class="[ $style.ImageInput_image ]"/>
      </div>
    </div>
  </Labelled>
</template>

<script>

export default {
  name: 'ImageInput',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String
    },
    error: {
      type: String
    },
    helpText: {
      type: String
    },
    helpTextHtml: {
      type: String
    },
    value: {
      type: String
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      height: 0
    }
  },
  created() {
  },
  methods: {
    chooseImage() {
      this.$dialogue.imageLibrary((file) => {
        this.$emit('input', file.cdnUrl)
      })
    },
    removeImage() {
      this.$emit('input', '')
    },
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" module>

.ImageInput {
  display: flex;
}

.ImageInput_image {
  border: 5px solid #ccc;
  max-width: 200px;
  margin-top: 15px;
}

</style>
